import { Controller } from "@hotwired/stimulus"
export { selectize } from 'selectize'
import 'selectize/dist/js/selectize.min.js'
import 'selectize/dist/css/selectize.css'

export default class extends Controller {
  static targets = [ 'supervisors', 'selectedSupervisors']
  // TODO: remove ugly jquery
  connect() {
    let selectedSupervisors = this.selectedSupervisorsTarget.value.split(' ')
    let dropdownMultiple = $("#supervisors").selectize({ plugins: ["remove_button"]})
    this.selectizeInstance = dropdownMultiple[0].selectize
    this.selectizeInstance.setValue(selectedSupervisors, false)
  }

  disconnect() {
    if (this.selectizeInstance) {
      this.selectizeInstance.destroy()
      this.selectizeInstance = null
    }
  }
}
